import { useMutation } from "@tanstack/react-query";
import { userInfApi, userListApi } from "components/api/member";
import { PAGE_ID_MEMBER_USER } from "components/constent";
import {
  apifield,
  initialPageNav,
  maskEmail,
  pageInitInf,
} from "components/utils/comm";
import { IPageNav } from "interface/index";
import { IUser } from "interface/member";
import { useEffect, useRef, useState } from "react";
import useListRowInfStroe from "store/listRowInf";
import usePageNoStore from "store/pageNo";
import { useUserParamsContext } from "./context";

// 회원상세
type ISearch = {
  param: any;
};

export const useSearchList = () => {
  const [rowData, setRowData] = useState<any[] | null>(null);
  const pageNavRef = useRef<IPageNav>(initialPageNav);
  const { param } = useUserParamsContext();

  const mutation = useMutation({
    mutationKey: ["member-user-search"],
    mutationFn: userListApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          const pageNav = res.data.pageNav;
          const userList = res.data.memList.map(
            (user: IUser, index: number) => {
              const { memNo, memSurnm, memFstnm, emlId, mobNo } = user;
              return {
                No: (pageNav.pageNo - 1) * pageNav.pageRows + index + 1,
                memNo,
                memSurnm,
                // memFstnm: "*".repeat(memFstnm.length),
                memFstnm,
                emlId: maskEmail(emlId),
                mobNo,
                detail: "상세보기",
              };
            }
          );

          setRowData(userList);
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });

  useEffect(() => {
    if (param) {
      const { uYn, ...res } = param;
      const uyn = !!uYn ? { [uYn]: "Y" } : undefined;

      mutation.mutate({
        ...res,
        ...uyn,
        ...pageInitInf,
      });
    }
  }, [param]);

  // NextPage
  const pageNo = usePageNoStore((state) => state.pageNo);
  const isCurrent = pageNo?.target === PAGE_ID_MEMBER_USER;

  //   soYn: uYn === "soYn" ? "Y" : undefined,
  //   lckYn: uYn === "lckYn" ? "Y" : undefined,

  useEffect(() => {
    if (isCurrent) {
      const params = {
        ...param,
        pageNo: pageNo?.no || 1,
        pageRows: pageNo?.pageRows,
      };

      mutation.mutate(params);
    }
  }, [pageNo?.no, pageNo?.pageRows]);

  return {
    rowData,
    pageNav: pageNavRef.current,
  };
};

// 매니저 상세
export const useGetData = () => {
  const listRowInf = useListRowInfStroe((state) => state.listRowInf);
  const userInfRef = useRef<IUser | null>(null);

  const mutation = useMutation({
    mutationKey: ["member-user-detail"],
    mutationFn: userInfApi,
    onSuccess(res) {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          userInfRef.current = res.data.memInf;
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });

  useEffect(() => {
    if (listRowInf.no) {
      mutation.mutate(listRowInf.no);
    }
  }, [listRowInf.no]);

  return {
    userInf: userInfRef.current,
  };
};
